import React from "react";
import { Typography } from "antd";

const { Paragraph } = Typography;

interface ShortIdParagraphProps extends React.ComponentProps<typeof Paragraph> {
  idValue?: string;
}

const ShortIdParagraph: React.FC<ShortIdParagraphProps> = ({
  idValue = "",
  ...props
}) => {
  const shortId = idValue ? `+${idValue.slice(-4)}` : "";

  return (
    <Paragraph {...(idValue ? { copyable: { text: idValue } } : {})} {...props}>
      {shortId}
    </Paragraph>
  );
};

export default ShortIdParagraph;
